export const TABLE_TYPES = {
    PLOT_2D: "2d",
    PLOT_3D: "3d"
};
